import i18n from "i18n";

export const questionTypeOptions = () => [
	{ label: i18n.t("option.checkbox"), value: "B" },
	{ label: i18n.t("option.checkboxList"), value: "C" },
	{ label: i18n.t("label.date"), value: "D" },
	{ label: i18n.t("option.dropdown"), value: "O" },
	{ label: i18n.t("option.longText"), value: "L" },
	{ label: i18n.t("option.number"), value: "N" },
	{ label: i18n.t("option.shortText"), value: "S" },
	{ label: i18n.t("option.time"), value: "T" },
];

export const questionTimingOptions = () => {
	const { customCaptions } =
		JSON.parse(sessionStorage.getItem("me")) ||
		JSON.parse(localStorage.getItem("me")) ||
		{};
	return [
		{
			label: i18n.t("option.beginningOfEntity", {
				entity: customCaptions?.service ?? i18n.t("entity.service"),
			}),
			value: "B",
		},
		{
			label: i18n.t("option.completionOfEntity", {
				entity: customCaptions?.service ?? i18n.t("entity.service"),
			}),
			value: "E",
		},
		{
			label: i18n.t("option.beginningOfAEntity", {
				entity: customCaptions?.stage ?? i18n.t("entity.stage"),
			}),
			value: "S",
		},
		{
			label: i18n.t("option.beginningOfAEntity", {
				entity: customCaptions?.zone ?? i18n.t("entity.zone"),
			}),
			value: "Z",
		},
	];
};
